import _ from 'lodash';
import type { ErrorFieldType } from '@/types';

const validateMail = (mail: string): ErrorFieldType[] => {
  const errors: ErrorFieldType[] = [];

  const mailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

  const valid = mailRegex.test(mail);

  if (!valid) {
    errors.push({ id: 'mail', message: 'Le format du courriel est invalide' });
  }

  if (_.size(mail) > 250) {
    errors.push({ id: 'mail', message: 'Le courriel ne doit pas dépasser 250 caractères' });
  }

  return errors;
};

export default validateMail;
